import React, { ReactNode, createContext, useState } from "react";

import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";

import { DEFAULT_REGION_CODE } from "../../../../constants/index";

interface Option {
  value: MonitoringCompany;
  label: string;
}

export interface SettingsContextType {
  monitoringCompany: MonitoringCompany;
  setMonitoringCompany: React.Dispatch<React.SetStateAction<MonitoringCompany>>;
  regionCode: string;
  setRegionCode: React.Dispatch<React.SetStateAction<string>>;
  roleId: string;
  setRoleId: React.Dispatch<React.SetStateAction<string>>;
  monitoringSeatsTotal: number | undefined;
  setMonitoringSeatsTotal: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  monitoringSeatsUsed: number | undefined;
  setMonitoringSeatsUsed: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  isOpenConfirmDialog: boolean;
  setIsOpenConfirmDialog: React.Dispatch<React.SetStateAction<boolean>>;
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSaving: boolean;
  setIsSaving: React.Dispatch<React.SetStateAction<boolean>>;
  monitoringCompanyOptions: Option[];
}

export const SettingsContext = createContext<SettingsContextType>(
  {} as SettingsContextType
);

interface SettingsContextProviderProps {
  children: ReactNode;
}

export const SettingsContextProvider = ({
  children,
}: SettingsContextProviderProps) => {
  const [roleId, setRoleId] = useState<string>("");
  const [monitoringCompany, setMonitoringCompany] = useState<MonitoringCompany>(
    MonitoringCompany.UNSPECIFIED
  );
  const [regionCode, setRegionCode] = useState<string>(DEFAULT_REGION_CODE);
  const [monitoringSeatsTotal, setMonitoringSeatsTotal] = useState<number>();
  const [monitoringSeatsUsed, setMonitoringSeatsUsed] = useState<number>();
  const [isOpenConfirmDialog, setIsOpenConfirmDialog] =
    useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const monitoringCompanyOptions: Option[] = [
    { value: MonitoringCompany.UNSPECIFIED, label: "Unspecified" },
    { value: MonitoringCompany.RAPIDSOS, label: "RapidSOS" },
    { value: MonitoringCompany.ART_SECURITY, label: "ART Security" },
  ];

  const contextValue: SettingsContextType = {
    roleId,
    setRoleId,
    monitoringCompany,
    setMonitoringCompany,
    regionCode,
    setRegionCode,
    monitoringSeatsTotal,
    setMonitoringSeatsTotal,
    monitoringSeatsUsed,
    setMonitoringSeatsUsed,
    isOpenConfirmDialog,
    setIsOpenConfirmDialog,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isSaving,
    setIsSaving,
    monitoringCompanyOptions,
  };

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
};
